import React, { useState } from 'react';
import '../style/Forms.scss';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useAuth } from './AuthContext';
import { API_BASE_URL } from '../config';

const Signup = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
  });

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // 1. Send the POST request to your backend
      const baseUrl = API_BASE_URL || '';
      const response = await axios.post(`${baseUrl}/api/signup`, formData);

      // 2. Check if the server responded with a success status
      if (response.status === 200 || response.status === 201) {
        toast.success("Account created successfully!");
        
        // 3. If server returns a token, save it and update auth state
        if (response.data.token) {
          const { token, username } = response.data;
          if (username) localStorage.setItem('username', username);
          login(token);
        }
        
        // 4. Small delay to let the toast show, then navigate
        setTimeout(() => {
          navigate('/mainpage'); 
        }, 1000);
      } else {
        // If the server sends a 200 but response.data.success is false
        const msg = response.data.message || "Signup failed";
        setError(msg);
        toast.error(msg);
      }
    } catch (err) {
      // 4. Handle actual server errors (400, 500, etc.)
      console.error("Signup Error:", err);
      const serverMsg = err.response?.data?.message || 'Server Error. Please try again later.';
      setError(serverMsg);
      toast.error(serverMsg);
    } finally {
      setLoading(false);
    }
  };
  
  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  return (
    <div className='signup-page'>
      <ToastContainer position='top-center' autoClose={2000} />
      <div className='heading'>
        <h1>Register</h1>
      </div>
      <div className='form-container'>
        {error && <div className='error-message' style={{color: 'red', textAlign: 'center', marginBottom: '10px'}}>{error}</div>}
        <form onSubmit={handleSubmit} className='form'>
          <label>Username:</label>
          <input
            type='text'
            name='username'
            value={formData.username}
            onChange={handleChange}
            placeholder='Enter your Username here'
            required
          />

          <label>Email:</label>
          <input
            type='email'
            name='email'
            value={formData.email}
            onChange={handleChange}
            placeholder='Enter your Email here'
            required
          />

          <label>Password:</label>
          <div className='password-input' style={{ position: 'relative' }}>
            <input
              type={showPassword ? 'text' : 'password'}
              name='password'
              value={formData.password}
              onChange={handleChange}
              placeholder='Enter your Password here'
              style={{ width: '100%' }}
              required
            />
            <span 
              onClick={togglePasswordVisibility} 
              style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer', color: '#666' }}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <br />
          <div style={{ marginBottom: '15px' }}>
            <Link to="/login">Already have an account? Login</Link>
          </div>

          <button type='submit' disabled={loading}>
            {loading ? 'Signing Up...' : 'Sign Up'}
          </button>
        </form>
      </div>

      <div className='disclaimer' style={{ marginTop: '20px', textAlign: 'center' }}>
        <p><strong>Disclaimer:</strong></p>
        <p style={{ fontSize: '14px', maxWidth: '400px', margin: '0 auto' }}>
          We securely store your data for authentication and personalized experience.
        </p>
      </div>
    </div>
  );
};

export default Signup;